"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _cardDetailApi = _interopRequireWildcard(require("@/api/cardDetailApi"));
var cardDetailApi = _cardDetailApi;
var fudouActiveApi = _interopRequireWildcard(require("@/api/fudouActiveApi"));
var projectApi = _interopRequireWildcard(require("@/api/projectManageApi"));
var _static = require("@/views/orderList/order/static");
var _CardDetailDrawer = _interopRequireDefault(require("./components/CardDetailDrawer.vue"));
var _vueCountTo = _interopRequireDefault(require("vue-count-to"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    CardDetailDrawer: _CardDetailDrawer.default,
    CountTo: _vueCountTo.default
  },
  data: function data() {
    return {
      constants: this.$constants,
      isMoney: true,
      listPram: {
        customerId: '',
        appId: '',
        cardId: '',
        cardNo: '',
        cardStatus: '',
        projectId: '',
        userName: '',
        phone: '',
        page: 1,
        limit: this.$constants.page.limit[0],
        empIntegralId: '',
        empName: '',
        type: '',
        cardPackageId: '',
        sendType: '',
        issueStartTime: '',
        issueEndTime: '',
        deleted: ''
      },
      listData: {
        list: [],
        total: 0,
        totalBeans: 0,
        availableBeans: 0
      },
      listLoading: false,
      cardStatusOptions: _static.orderCardOption,
      typeOptions: [{
        value: 1,
        label: '固定套餐'
      }, {
        value: 2,
        label: '福卡充值'
      }, {
        value: 3,
        label: '企业直充'
      }, {
        value: 4,
        label: '权益兑换'
      }, {
        value: 5,
        label: '权益充值'
      }],
      sendTypeOptions: [{
        value: 1,
        label: '测试卡'
      }, {
        value: 2,
        label: '体验卡'
      }, {
        value: 3,
        label: '内部员工卡'
      }, {
        value: 4,
        label: '出单卡'
      }, {
        value: 5,
        label: '赠送'
      }, {
        value: 6,
        label: '其他'
      }],
      deletedOptions: [{
        value: 0,
        label: '正常'
      }, {
        value: 1,
        label: '已作废'
      }],
      customerOptions: [],
      miniappOptions: [],
      cardOptions: [],
      projectOptions: [],
      customersLoading: false,
      miniappsLoading: false,
      projectsLoading: false,
      cardsLoading: false,
      customersLoadingMore: false,
      miniappsLoadingMore: false,
      projectsLoadingMore: false,
      cardsLoadingMore: false,
      customersNoMore: false,
      miniappsNoMore: false,
      projectsNoMore: false,
      cardsNoMore: false,
      customerParams: {
        page: 1,
        limit: 20,
        keyword: ''
      },
      miniappParams: {
        page: 1,
        limit: 20,
        keyword: ''
      },
      projectParams: {
        page: 1,
        limit: 20,
        projectName: ''
      },
      cardParams: {
        page: 1,
        limit: 20,
        keyword: ''
      },
      exportLoading: false,
      activeTab: '福卡',
      isFilterCollapsed: true
    };
  },
  mounted: function mounted() {
    if (this.$route.query.projectId) {
      this.listPram.projectId = this.$route.query.projectId;
    }
    this.handlerGetListData();
    // 不再自动加载选项数据，改为点击时加载
    // this.fetchInitialOptions();

    // Add keyboard shortcuts
    window.addEventListener('keydown', this.handleKeyDown);
  },
  beforeDestroy: function beforeDestroy() {
    // Remove event listeners when component is destroyed
    window.removeEventListener('keydown', this.handleKeyDown);
  },
  watch: {
    activeTab: function activeTab() {
      // Reset page and set type based on active tab
      this.listPram.page = 1;
      this.listPram.cardType = this.activeTab === '福卡' ? 1 : 3;
      this.handlerGetListData();
    }
  },
  methods: {
    fetchInitialOptions: function fetchInitialOptions() {
      this.fetchCustomers();
      this.fetchMiniapps();
      this.fetchCards();
      this.fetchProjects();
    },
    fetchCustomers: function fetchCustomers() {
      var _this = this;
      var keyword = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      this.customersLoading = true;
      this.customerParams.keyword = keyword;
      projectApi.getCustomerList(this.customerParams).then(function (res) {
        if (res) {
          var customerList = Array.isArray(res) ? res : [];
          if (_this.customerParams.page === 1) {
            _this.customerOptions = customerList.map(function (item) {
              return {
                value: item.id,
                label: item.name || item.customerName
              };
            });
          } else {
            _this.customerOptions = [].concat(_toConsumableArray(_this.customerOptions), _toConsumableArray(customerList.map(function (item) {
              return {
                value: item.id,
                label: item.name || item.customerName
              };
            })));
          }
          _this.customersNoMore = customerList.length < _this.customerParams.limit;
        } else {
          _this.customersNoMore = true;
        }
        _this.customersLoading = false;
        _this.customersLoadingMore = false;
      }).catch(function (err) {
        _this.$message.error('获取客户列表失败');
        _this.customersLoading = false;
        _this.customersLoadingMore = false;
        _this.customersNoMore = true;
      });
    },
    searchCustomers: function searchCustomers(query) {
      this.customerParams.page = 1;
      this.customersNoMore = false;
      if (query) {
        this.fetchCustomers(query);
      } else {
        this.fetchCustomers();
      }
    },
    loadMoreCustomers: function loadMoreCustomers() {
      if (this.customersLoadingMore || this.customersNoMore) return;
      this.customersLoadingMore = true;
      this.customerParams.page += 1;
      this.fetchCustomers(this.customerParams.keyword);
    },
    fetchMiniapps: function fetchMiniapps() {
      var _this2 = this;
      var keyword = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      this.miniappsLoading = true;
      this.miniappParams.keyword = keyword;
      (0, _cardDetailApi.getMiniappList)({
        keyword: keyword
      }).then(function (res) {
        if (res && Array.isArray(res)) {
          if (_this2.miniappParams.page === 1) {
            _this2.miniappOptions = res.map(function (item) {
              return {
                value: item.id,
                label: item.appName
              };
            });
          } else {
            _this2.miniappOptions = [].concat(_toConsumableArray(_this2.miniappOptions), _toConsumableArray(res.map(function (item) {
              return {
                value: item.id,
                label: item.appName
              };
            })));
          }
          _this2.miniappsNoMore = res.length < _this2.miniappParams.limit;
        } else {
          _this2.miniappsNoMore = true;
        }
        _this2.miniappsLoading = false;
        _this2.miniappsLoadingMore = false;
      }).catch(function (err) {
        _this2.$message.error('获取小程序列表失败');
        _this2.miniappsLoading = false;
        _this2.miniappsLoadingMore = false;
        _this2.miniappsNoMore = true;
      });
    },
    searchMiniapps: function searchMiniapps(query) {
      this.miniappParams.page = 1;
      this.miniappsNoMore = false;
      if (query) {
        this.fetchMiniapps(query);
      } else {
        this.fetchMiniapps();
      }
    },
    loadMoreMiniapps: function loadMoreMiniapps() {
      if (this.miniappsLoadingMore || this.miniappsNoMore) return;
      this.miniappsLoadingMore = true;
      this.miniappParams.page += 1;
      this.fetchMiniapps(this.miniappParams.keyword);
    },
    fetchCards: function fetchCards() {
      var _this3 = this;
      var keyword = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      this.cardsLoading = true;
      var params = {
        page: this.cardParams.page,
        limit: this.cardParams.limit,
        keyword: keyword
      };
      fudouActiveApi.selectCard(keyword).then(function (res) {
        if (res && Array.isArray(res)) {
          if (_this3.cardParams.page === 1) {
            _this3.cardOptions = res.map(function (item) {
              return {
                value: item.id,
                label: item.card_name
              };
            });
          } else {
            _this3.cardOptions = [].concat(_toConsumableArray(_this3.cardOptions), _toConsumableArray(res.map(function (item) {
              return {
                value: item.id,
                label: item.card_name
              };
            })));
          }
          _this3.cardsNoMore = res.length < _this3.cardParams.limit;
        } else {
          _this3.cardsNoMore = true;
        }
        _this3.cardsLoading = false;
        _this3.cardsLoadingMore = false;
      }).catch(function (err) {
        _this3.$message.error('获取卡片列表失败');
        _this3.cardsLoading = false;
        _this3.cardsLoadingMore = false;
        _this3.cardsNoMore = true;
      });
    },
    loadMoreCards: function loadMoreCards() {
      if (this.cardsLoadingMore || this.cardsNoMore) return;
      this.cardsLoadingMore = true;
      this.cardParams.page += 1;
      this.fetchCards();
    },
    fetchProjects: function fetchProjects() {
      var _this4 = this;
      var keyword = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      this.projectsLoading = true;
      var params = {
        page: this.projectParams.page,
        limit: this.projectParams.limit,
        projectName: keyword
      };
      projectApi.getFudouProjectList(params).then(function (res) {
        if (res && res.page && Array.isArray(res.page.list)) {
          var projectList = res.page.list;
          if (_this4.projectParams.page === 1) {
            _this4.projectOptions = projectList.map(function (item) {
              return {
                value: item.id,
                label: "".concat(item.projectName, " (ID:").concat(item.id, ")")
              };
            });
          } else {
            _this4.projectOptions = [].concat(_toConsumableArray(_this4.projectOptions), _toConsumableArray(projectList.map(function (item) {
              return {
                value: item.id,
                label: "".concat(item.projectName, " (ID:").concat(item.id, ")")
              };
            })));
          }
          _this4.projectsNoMore = projectList.length < _this4.projectParams.limit;
          if (_this4.projectParams.page === 1 && res.typeSelect && Array.isArray(res.typeSelect)) {
            _this4.projectTypeOptions = res.typeSelect.map(function (item) {
              return {
                value: item.key,
                label: item.value
              };
            });
          }
        } else {
          _this4.projectsNoMore = true;
        }
        _this4.projectsLoading = false;
        _this4.projectsLoadingMore = false;
      }).catch(function (err) {
        _this4.$message.error('获取项目列表失败');
        _this4.projectsLoading = false;
        _this4.projectsLoadingMore = false;
        _this4.projectsNoMore = true;
      });
    },
    searchProjects: function searchProjects(query) {
      this.projectParams.page = 1;
      this.projectsNoMore = false;
      this.projectParams.projectName = query;
      if (query) {
        this.fetchProjects(query);
      } else {
        this.fetchProjects();
      }
    },
    loadMoreProjects: function loadMoreProjects() {
      if (this.projectsLoadingMore || this.projectsNoMore) return;
      this.projectsLoadingMore = true;
      this.projectParams.page += 1;
      this.fetchProjects(this.projectParams.projectName);
    },
    handerSearch: function handerSearch() {
      this.listPram.page = 1;
      this.handlerGetListData();
    },
    handlerGetListData: function handlerGetListData() {
      var _this5 = this;
      this.listLoading = true;
      var apiParams = {
        page: this.listPram.page,
        limit: this.listPram.limit,
        projectId: this.listPram.projectId || undefined,
        appId: this.listPram.appId || undefined,
        cardId: this.listPram.cardId || undefined,
        empIntegralId: this.listPram.empIntegralId || this.listPram.cardNo || undefined,
        empName: this.listPram.empName || this.listPram.userName || undefined,
        phone: this.listPram.phone || undefined,
        cardType: this.activeTab === '福卡' ? 1 : 3,
        type: this.listPram.type,
        customerId: this.listPram.customerId || undefined,
        status: this.listPram.cardStatus || undefined,
        cardPackageId: this.listPram.cardPackageId || undefined,
        sendType: this.listPram.sendType || undefined,
        issueStartTime: this.listPram.issueStartTime || undefined,
        issueEndTime: this.listPram.issueEndTime || undefined,
        deleted: this.listPram.deleted === '' ? undefined : this.listPram.deleted
      };
      (0, _cardDetailApi.getCardList)(apiParams).then(function (res) {
        if (res && res.page) {
          _this5.listData = {
            list: res.page.list || [],
            total: res.page.total || 0
          };
          if (res.statistics) {
            _this5.listData.totalBeans = res.statistics.integral || 0;
            _this5.listData.availableBeans = res.statistics.balance || 0;
          } else {
            _this5.listData.totalBeans = _this5.listData.list.reduce(function (sum, item) {
              return sum + (parseFloat(item.integral) || 0);
            }, 0);
            _this5.listData.availableBeans = _this5.listData.list.reduce(function (sum, item) {
              return sum + (parseFloat(item.balance) || 0);
            }, 0);
          }
          if (res.statusSelect && Array.isArray(res.statusSelect)) {
            _this5.cardStatusOptions = res.statusSelect.map(function (item) {
              return {
                value: item.key,
                label: item.value
              };
            });
          }
        } else {
          _this5.listData = {
            list: [],
            total: 0,
            totalBeans: 0,
            availableBeans: 0
          };
        }
        _this5.listLoading = false;
      }).catch(function (err) {
        _this5.$message.error('获取卡片明细列表失败');
        _this5.listData = {
          list: [],
          total: 0,
          totalBeans: 0,
          availableBeans: 0
        };
        _this5.listLoading = false;
      });
    },
    handleDetail: function handleDetail(row) {
      if (row && row.empIntegralId) {
        this.$refs.cardDetailDrawerRef.openDetail(row.empIntegralId, row.cardStatus, this.activeTab === '福卡' ? 1 : 3);
      } else if (row && row.id) {
        this.$refs.cardDetailDrawerRef.openDetail(row.id, row.cardStatus, this.activeTab === '福卡' ? 1 : 3);
      } else {
        this.$message.error('无法获取卡片ID');
      }
    },
    handleExport: function handleExport() {
      var _this6 = this;
      this.exportLoading = true;
      var exportParams = {
        projectId: this.listPram.projectId || undefined,
        appId: this.listPram.appId || undefined,
        cardId: this.listPram.cardId || undefined,
        empIntegralId: this.listPram.empIntegralId || this.listPram.cardNo || undefined,
        empName: this.listPram.empName || this.listPram.userName || undefined,
        phone: this.listPram.phone || undefined,
        cardType: this.activeTab === '福卡' ? 1 : 3,
        customerId: this.listPram.customerId || undefined,
        status: this.listPram.cardStatus || undefined,
        cardPackageId: this.listPram.cardPackageId || undefined,
        sendType: this.listPram.sendType || undefined,
        deleted: this.listPram.deleted === '' ? undefined : this.listPram.deleted
      };
      (0, _cardDetailApi.exportCardDetail)(exportParams).then(function (res) {
        if (res && res.fileName) {
          try {
            // 获取文件下载URL
            var downloadUrl = res.fileName;

            // 创建下载链接并点击
            var link = document.createElement('a');
            link.style.display = 'none';
            link.href = downloadUrl;

            // 从URL中提取文件名
            var fileName = downloadUrl.substring(downloadUrl.lastIndexOf('/') + 1);

            // 直接打开链接，不使用download属性，避免跨域问题
            link.setAttribute('target', '_blank');
            document.body.appendChild(link);
            link.click();
            setTimeout(function () {
              document.body.removeChild(link);
            }, 100);
            _this6.$message.success('导出成功，请在新窗口中下载文件');
          } catch (err) {
            _this6.$message.error('下载文件失败: ' + err.message);
          }
        } else {
          _this6.$message.error(res && res.message ? res.message : '导出失败');
        }
      }).catch(function (err) {
        _this6.$message.error('导出失败: ' + (err.message || '未知错误'));
      }).finally(function () {
        _this6.exportLoading = false;
      });
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listPram.limit = val;
      this.handlerGetListData();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listPram.page = val;
      this.handlerGetListData();
    },
    getStatusName: function getStatusName(status) {
      // Handle "未定义" and similar statuses that should appear as "未绑定" in UI
      if (status === '未定义' || status === '未绑定' || status === '未指定') {
        return '未绑定';
      }

      // Handle other string statuses
      if (typeof status === 'string') {
        if (status === '已发放' || status === '已发放卡') return '已发放';
        if (status.includes('未')) return '未绑定';
      }

      // Special case for the status shown in the screenshot
      if (status === null || status === undefined || status === '') {
        return '未绑定';
      }

      // Handle numeric statuses
      var statusValue = parseInt(status);
      if (isNaN(statusValue)) return status || '未知状态';
      var statusMap = {
        1: '已生成',
        2: '已绑定',
        3: '已作废',
        4: '已核销',
        5: '已过期',
        6: '待使用',
        7: '使用中',
        8: '已冻结',
        9: '已回收',
        10: '已发放'
      };
      return statusMap[statusValue] || status;
    },
    getStatusType: function getStatusType(status) {
      // Handle "未定义" and similar statuses that should appear as "未绑定" in UI
      if (status === '未定义' || status === '未绑定' || status === '未指定') {
        return 'unbind';
      }

      // Handle other string statuses
      if (typeof status === 'string') {
        if (status === '已发放' || status === '已发放卡') return 'success';
        if (status.includes('未')) return 'unbind';
      }

      // Special case for the status shown in the screenshot
      if (status === null || status === undefined || status === '') {
        return 'unbind';
      }

      // Handle numeric statuses
      var statusValue = parseInt(status);
      if (isNaN(statusValue)) return 'info';
      var typeMap = {
        1: 'primary',
        // 已生成 - 蓝色
        2: 'success',
        // 已绑定 - 绿色
        3: 'danger',
        // 已作废 - 红色
        4: 'warning',
        // 已核销 - 橙色
        5: 'info',
        // 已过期 - 灰色
        6: 'warning',
        // 待使用 - 橙色
        7: 'primary',
        // 使用中 - 蓝色
        8: 'info',
        // 已冻结 - 灰色
        9: 'danger',
        // 已回收 - 红色
        10: 'success' // 已发放 - 绿色
      };
      return typeMap[statusValue] || 'info';
    },
    getStatusIcon: function getStatusIcon(status) {
      // Handle "未定义" and similar statuses that should appear as "未绑定" in UI
      if (status === '未定义' || status === '未绑定' || status === '未指定') {
        return 'el-icon-info';
      }

      // Handle other string statuses
      if (typeof status === 'string') {
        if (status === '已发放' || status === '已发放卡') return 'el-icon-circle-check';
        if (status.includes('未')) return 'el-icon-info';
      }

      // Special case for the status shown in the screenshot
      if (status === null || status === undefined || status === '') {
        return 'el-icon-info';
      }

      // Handle "已发放" status
      if (status === '已发放') return 'el-icon-circle-check';

      // Handle numeric statuses
      var statusValue = parseInt(status);
      if (isNaN(statusValue)) return 'el-icon-info';
      var iconMap = {
        1: 'el-icon-check',
        // 已生成
        2: 'el-icon-user',
        // 已绑定
        3: 'el-icon-close',
        // 已作废
        4: 'el-icon-shopping-cart-full',
        // 已核销
        5: 'el-icon-time',
        // 已过期
        6: 'el-icon-watch',
        // 待使用
        7: 'el-icon-mobile-phone',
        // 使用中
        8: 'el-icon-lock',
        // 已冻结
        9: 'el-icon-back',
        // 已回收
        10: 'el-icon-circle-check' // 已发放
      };
      return iconMap[statusValue] || 'el-icon-info';
    },
    getProjectTypeName: function getProjectTypeName(type) {
      var found = this.projectTypeOptions.find(function (item) {
        return item.value === type;
      });
      return found ? found.label : type;
    },
    formatDateTime: function formatDateTime(dateTime) {
      if (!dateTime) return '-';
      if (dateTime instanceof Date) {
        var year = dateTime.getFullYear();
        var month = String(dateTime.getMonth() + 1).padStart(2, '0');
        var day = String(dateTime.getDate()).padStart(2, '0');
        var hours = String(dateTime.getHours()).padStart(2, '0');
        var minutes = String(dateTime.getMinutes()).padStart(2, '0');
        var seconds = String(dateTime.getSeconds()).padStart(2, '0');
        return "".concat(year, "-").concat(month, "-").concat(day, " ").concat(hours, ":").concat(minutes, ":").concat(seconds);
      }
      return dateTime;
    },
    formatNumber: function formatNumber(val) {
      if (val === undefined || val === null) return '0';

      // Check if the value is a string
      if (typeof val === 'string') {
        // Try to convert to a number first
        val = parseFloat(val);
        if (isNaN(val)) return '0';
      }

      // Format with thousand separators
      return val.toLocaleString();
    },
    clearFilters: function clearFilters() {
      this.listPram.customerId = '';
      this.listPram.appId = '';
      this.listPram.cardId = '';
      this.listPram.cardNo = '';
      this.listPram.cardStatus = '';
      this.listPram.projectId = '';
      this.listPram.userName = '';
      this.listPram.phone = '';
      this.listPram.internalName = '';
      this.listPram.cardPackageId = '';
      this.listPram.deleted = '';
      this.listPram.page = 1;
      this.listPram.cardType = this.activeTab === '福卡' ? 1 : 3;
      this.handlerGetListData();
    },
    resetSearch: function resetSearch() {
      this.listPram = {
        customerId: '',
        appId: '',
        cardId: '',
        cardNo: '',
        cardStatus: '',
        projectId: '',
        userName: '',
        phone: '',
        internalName: '',
        type: null,
        cardType: this.activeTab === '福卡' ? 1 : 3,
        page: 1,
        limit: this.$constants.page.limit[0],
        empIntegralId: '',
        empName: '',
        cardPackageId: '',
        sendType: '',
        issueStartTime: '',
        issueEndTime: '',
        deleted: ''
      };

      // Reset any route query params if they exist
      if (this.$route.query.projectId) {
        this.$router.replace({
          path: this.$route.path,
          query: {}
        });
      }

      // Get fresh data with no filters
      this.handlerGetListData();

      // Show success message
      this.$message.success('筛选条件已重置');
    },
    // Add keyboard shortcut handler
    handleKeyDown: function handleKeyDown(e) {
      // Only handle if no modals are open
      if (document.querySelector('.el-dialog__wrapper') || document.querySelector('.el-drawer__open') || document.activeElement.tagName === 'INPUT' || document.activeElement.tagName === 'TEXTAREA') {
        return;
      }

      // Handle different key combinations
      if (e.ctrlKey && e.key === 'f') {
        // Prevent browser search
        e.preventDefault();
        // Focus on first input field
        var firstInput = document.querySelector('.list-form input');
        if (firstInput) firstInput.focus();
      } else if (e.ctrlKey && e.key === 'r') {
        // Prevent browser reload
        e.preventDefault();
        // Refresh data
        this.refreshData();
      } else if (e.key === 'Escape') {
        // Reset search
        this.resetSearch();
      }
    },
    // Refresh data
    refreshData: function refreshData() {
      this.handlerGetListData();
    },
    formatMoney: function formatMoney(value) {
      if (!value) return '0.00';
      return parseFloat(value).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    },
    isUndefinedStatus: function isUndefinedStatus(status) {
      // Check for all variations of "未绑定" status
      return status === '未绑定' || status === null || status === undefined || status === '' || status === '未定义' || status === '未指定';
    }
  }
};